(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  function slideshowAutoFitInit(slideshowEl) {
    var slider = slideshowEl.querySelector('[id^="Slider-"]');
    if (!slider) return;

    function getVisibleImage(slideEl) {
      if (!slideEl) return null;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var img = null;
      if (isMobile) {
        img = slideEl.querySelector('.slideshow__media-mobile-only');
      }
      if (!img) {
        img = slideEl.querySelector('.slideshow__media-desktop-only') || slideEl.querySelector('.slideshow__media img');
      }
      return img;
    }

    function applyHeight(slideEl) {
      if (!slideEl || !slideEl.classList.contains('slide--auto-fit')) {
        slider.classList.remove('slideshow--auto-fit-active');
        slider.style.height = '';
        return;
      }

      var img = getVisibleImage(slideEl);
      if (!img) return;

      var setHeight = function () {
        if (!img.naturalWidth || !img.naturalHeight) return;
        var ratio = img.naturalWidth / img.naturalHeight;
        var width = slider.clientWidth;
        slider.classList.add('slideshow--auto-fit-active');
        slider.style.height = (width / ratio) + 'px';
      };

      if (img.complete && img.naturalWidth) {
        setHeight();
      } else {
        img.addEventListener('load', setHeight, { once: true });
      }
    }

    function getActiveSlide() {
      var slides = slider.querySelectorAll('.slideshow__slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('aria-hidden') === 'false') return slides[i];
      }
      return slider.querySelector('.slideshow__slide');
    }

    applyHeight(getActiveSlide());

    slideshowEl.addEventListener('slideChanged', function (event) {
      applyHeight(event.detail.currentElement);
    });

    window.addEventListener('resize', function () {
      applyHeight(getActiveSlide());
    });

    var mq = window.matchMedia('(max-width: 749px)');
    if (mq.addEventListener) {
      mq.addEventListener('change', function () {
        applyHeight(getActiveSlide());
      });
    }
  }

  document.querySelectorAll('slideshow-component').forEach(slideshowAutoFitInit);

  // Theme editor (Customizer) re-renders sections via AJAX on every settings
  // change, which creates fresh slideshow-component elements. Re-attach the
  // auto-fit logic whenever that happens, otherwise it only ever runs once
  // on the very first page load.
  document.addEventListener('shopify:section:load', function (event) {
    var slideshows = event.target.querySelectorAll('slideshow-component');
    slideshows.forEach(slideshowAutoFitInit);
  });

  } catch(e) { console.error(e); }
})();
})();
